<script setup>
import { useUiStore } from '@/stores/UiStore'
import DeleteLoadAction from './DeleteLoadAction.vue'
import UpdateTruckAction from './UpdateTruckAction.vue'
import EmailDriverAction from './EmailDriverAction.vue'
import UpdateDriverAction from './UpdateDriverAction.vue'
import UpdateStatusAction from './UpdateStatusAction.vue'
import SendLoadToEldAction from './SendLoadToEldAction.vue'
import UpdateTruckLocationAction from './UpdateTruckLocationAction.vue'
import LoadDrawer from '@/components/grid/drawers/dispatch/LoadDrawer.vue'
import {
    DELETE_LOAD,
    SEND_ELD,
    EMAIL_DRIVER,
    UPDATE_TRUCK,
    UPDATE_DRIVER,
    UPDATE_STATUS,
    UPDATE_TRUCK_LOCATION,
    VIEW_LOAD,
} from '@/constants/dispatch'

const ui = useUiStore()
</script>

<template>
    <load-drawer v-if="ui.isActionActive(VIEW_LOAD)" />
    <delete-load-action v-if="ui.isActionActive(DELETE_LOAD)" />
    <update-truck-action v-if="ui.isActionActive(UPDATE_TRUCK)" />
    <email-driver-action v-if="ui.isActionActive(EMAIL_DRIVER)" />
    <send-load-to-eld-action v-if="ui.isActionActive(SEND_ELD)" />
    <update-status-action v-if="ui.isActionActive(UPDATE_STATUS)" />
    <update-driver-action v-if="ui.isActionActive(UPDATE_DRIVER)" />
    <update-truck-location-action
        v-if="ui.isActionActive(UPDATE_TRUCK_LOCATION)"
    />
</template>
